import axiosInstance from './interceptor'


//External User flow - Creating New Client Request
export const sendOtpToRegisterClient = async (params: any) => {

    return await axiosInstance.post(`/SendOTPtoRegisterClient`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const validateOtpToRegisterClient = async (params: any) => {

    return await axiosInstance.post(`/ValidateOTPtoRegisterClient`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//Internal User flow - Creating New Client Request
export const getAllOnboardRequestForReviewers = async (pageNo: any, searchValue?: string, contactName?: string, email?: string, tabName?: any) => {
    
    let url = `/OnboardClientRequest/GetAllOnboardRequestsForReviewers/${pageNo}/${tabName}`;
    
    const params = new URLSearchParams();
    
    if (searchValue && searchValue.trim()) {
        params.append('businessName', searchValue.trim());
    }
    if (contactName && contactName.trim()) {
        params.append('contactName', contactName.trim());
    }
    if (email && email.trim()) {
        params.append('email', email.trim());
    }
    
    if (params.toString()) {
        url += `?${params.toString()}`;
    }

    return await axiosInstance.get(url).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getOnboardRequestDetails = async (id: any) => {

    return await axiosInstance.get(`/OnboardClientRequest/GetOnboardRequest/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const reviewOnboardRequest = async (params: any) => {

    return await axiosInstance.put(`/OnboardClientRequest/ReviewOnboardRequest`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const actionOnboardRequest = async (params: any) => {

    return await axiosInstance.put(`/OnboardClientRequest/ActionOnboardRequest`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getElecodes = async () => {

    return await axiosInstance.get(`/BusinessUnit/GetElecodes`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getBUCodes = async (buCode: any) => {

    return await axiosInstance.get(`/BusinessUnit/GetBUCodes/${buCode}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const reDraft = async (param:any) => {

    return await axiosInstance.put(`/OnboardClientRequest/SendRedraftToCustomer`,param).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const paymentTermsOptionsApi = async () => {

    return await axiosInstance.get(`/ELVISMasterData/GetPaymentTerms`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const clientCodeExist = async (nameCheck:any) => {

    return await axiosInstance.get(`/ELVISMasterData/DoesClientCodeExist/${nameCheck}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getASMBasedStateId = async (id: any) => {

    return await axiosInstance.get(`/OnboardClientRequest/GetASMsByStateId/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const sendApprovalEmail = async (params: any) => {

    return await axiosInstance.put(`/OnboardClientRequest/SendOnboardClientUpdateRequest`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}


export const sendRejectStatusToCustomer = async (params: any) => {

    return await axiosInstance.put(`/OnboardClientRequest/SendRejectStatusToCustomer`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const newDefaultClientPriceList = async () => {

    return await axiosInstance.get(`/PriceList/GetDefaultPriceListNames`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//Signature Api

export const getSignature = async (signatureId:any) => {

    return await axiosInstance.get(`/ImageBlob/GetClientSignature/${signatureId}`, {
        responseType: 'blob'
    }).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getClientOnboardingStates = async () => {

    return await axiosInstance.get(`/OnboardClientRequest/GetReportStates`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getBumaAsByState = async (stateId: any) => {

    return await axiosInstance.get(`/OnboardClientRequest/GetBUMAsByStateId/${stateId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Get Bank Letters api
export const getBankLetters = async () => {

    return await axiosInstance.get(`/OnboardClientRequest/GetBankLetterNames`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}
